<template>
  <v-dialog
    v-model="show"
    max-width="400"
    @input="onClose"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">QR карты</span>
      </v-card-title>
      <v-card-text>
        <div
          v-for="c in cards"
          :key="c.uid"
          class="mb-4 text-center"
        >
          <div class="text-subtitle-1 font-weight-bold mb-1">
            UID {{ c.uid }}
          </div>
          <v-progress-circular
            v-if="c.loading"
            indeterminate
          />
          <img
            v-else-if="c.url"
            :src="c.url"
            style="max-width: 240px"
            alt="QR карты"
          >
          <v-alert
            v-else
            type="error"
            dense
            outlined
            class="mb-0"
          >
            {{ c.error }}
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="show = false"
        >
          <span class="mx-4">Закрыть</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SkudCardService } from '@/views/skud/shared/services/skud-card-service'

export default {
  name: 'SkudCardQrDialog',
  data () {
    return {
      svc: null,
      show: false,
      cards: []
    }
  },
  mounted () {
    this.svc = new SkudCardService()
  },
  methods: {
    async open (item) {
      if (!item.place_id) {
        this.$store.commit('snackbar', 'Неизвестное место карты')
        return
      }
      // QR строится из UID карты (kind 0), остальные виды креденшелов мимо эндпоинта.
      const cards = (item.active_uids || []).filter(c => Number(c.kind) === 0)
      if (!cards.length) {
        this.$store.commit('snackbar', 'Нет активных карт')
        return
      }
      this.cards = cards.map(c => ({ uid: c.uid, loading: true, url: null, error: null }))
      this.show = true
      this.cards.forEach(async (c) => {
        const res = await this.svc.getCardQr(item.place_id, c.uid)
        c.loading = false
        if (res.ok) c.url = res.url
        else c.error = res.error
      })
    },
    onClose (v) {
      if (v) return
      this.cards.forEach(c => c.url && URL.revokeObjectURL(c.url))
      this.cards = []
    }
  }
}
</script>
